import React from 'react';
import classnames from 'classnames';
import { node, string } from 'prop-types';
import { localeSettings, user, abTests, rollouts } from '../../../PropTypes';
import { HEADER_SOURCE, PACKAGE_CLASSNAME } from '../../../constants';
import { DEFAULT_STYLE, LINK_CLASSNAME, LINK_TITLE_CLASSNAME } from '../constants';

const LanguageLink = (
    { style = DEFAULT_STYLE, className, Component },
    { locale, displayedLocale, supportedLanguages, user, abTests, rollouts }
) => {
    const props = {
        locale,
        displayedLocale,
        supportedLanguages,
        user,
        style,
        className: classnames(LINK_CLASSNAME, className),
        titleClassName: LINK_TITLE_CLASSNAME,
        modalClassName: PACKAGE_CLASSNAME,
        source: HEADER_SOURCE,
        abTests,
        rollouts,
    };

    return <Component {...props} />;
};

LanguageLink.propTypes = {
    className: string,
    style: string,
    Component: node.isRequired,
};

LanguageLink.contextTypes = {
    locale: localeSettings.locale,
    displayedLocale: localeSettings.displayedLocale,
    supportedLanguages: localeSettings.supportedLanguages,
    user,
    abTests,
    rollouts,
};

export default LanguageLink;
